
import React from 'react';

const ExtendSVG = () =>
  <svg height="24px" width="16px" version="1.1" viewBox="0 0 16 24">
    <g fill="none" stroke="none" strokeWidth="1">
      <g transform="translate(-304.000000, -501.000000)">
        <g transform="translate(157.000000, 116.000000)">
          <g transform="translate(-9.000000, 25.000000)">
            <g transform="translate(0.000000, 339.884018)">
              <g transform="translate(157.000000, 17.000000)">
                <g transform="translate(0.000000, 4.000000)">
                  <path d="M13.5162632,6.53763667 L13.5162632,13.8240367 C13.5162632,15.7422367 12.0219474,17.2970367 10.1783684,17.2970367 L8.50942105,17.2970367 L8.50942105,21.8119367 L5.17152632,21.8119367 L5.17152632,17.2970367 L3.50257895,17.2970367 C1.65973684,17.2970367 0.164684211,15.7422367 0.164684211,13.8240367 L0.164684211,6.53073667 L1.49984211,6.53073667 L4.17015789,6.53073667 L9.51078947,6.53073667 L12.1811053,6.53073667 L13.5162632,6.53763667 Z" fill="#FFFFFF"/>
                  <path d="M13.5162632,6.53763667 L13.5162632,13.8240367 C13.5162632,15.7422367 12.0219474,17.2970367 10.1783684,17.2970367 L8.50942105,17.2970367 L8.50942105,21.8119367 L5.17152632,21.8119367 L5.17152632,17.2970367 L3.50257895,17.2970367 C1.65973684,17.2970367 0.164684211,15.7422367 0.164684211,13.8240367 L0.164684211,6.53073667 L1.49984211,6.53073667 L4.17015789,6.53073667 L9.51078947,6.53073667 L12.1811053,6.53073667 L13.5162632,6.53763667 Z" stroke="#222228" strokeWidth="1.155"/>
                  <path d="M3.65915789,6.53089 L3.65915789,0.0939566667" fill="#FFFFFF"/>
                  <path d="M3.65915789,6.53089 L3.65915789,0.0939566667" stroke="#222228" strokeLinecap="round" strokeWidth="1.155"/>
                  <path d="M10.0220105,6.53089 L10.0220105,0.0939566667" fill="#FFFFFF"/>
                  <path d="M10.0220105,6.53089 L10.0220105,0.0939566667" stroke="#222228" strokeLinecap="round" strokeWidth="1.155"/>
                  <path d="M3.65775789,10.03816 L10.0218632,10.03816" stroke="#3445DC" strokeWidth="1.155"/>
                  <path d="M4.91304211,12.3879167 L8.76672632,12.3879167" stroke="#3445DC" strokeWidth="1.155"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default ExtendSVG;


// WEBPACK FOOTER //
// ./src/svg/ExtendSVG.js